<app-hourglass *ngIf="showSpinner"></app-hourglass>
<mat-card *ngIf="!showSpinner" class="cmn-flex flex">
    <mat-card-content>
        <app-autocomplete #autoComplete (addRequest)="newTemplate()" (autocompleteInput)="onTemplateChanged($event)"
                          (selection)="selectTemplate($event)" [buttonConfig]="buttonConfig"
                          [hint]="'Search by ID, Name or Creator\'s Email'" [label]="'Search for a Template'"
                          [objects]="autocompleteTemplate" [doAutofocus]="false"
                          [options]="autocompleteTemplateFormatted" [searchName]="'Template'"
                          id="selectTemplateName"></app-autocomplete>
    </mat-card-content>
</mat-card>

<div *ngIf="!showSpinner && !selectedTemplate">
    <app-grid #grid
              (activate)="onActivate($event)"
              (pageChange)="pageCallback($event)"
              (sortChange)="sortCallback($event)"
              (filterChange)="filterChange($event)"
              [filter]="userCreatedTemplatesSetting"
              [filterToggle]="showGridFilter"
              [filterDesc]="'Only show templates you have created'"
              [headers]="header"
              [width]="width"
              [rows]="templates"
              [page]="page"
              [showDeactiveIcon]="false"
              id="grid"></app-grid>
</div>

<mat-card *ngIf="!showSpinner && selectedTemplate" class="cmn-flex row">
    <div class="cmn-flex row gutters-lg align-baseline">
        <label *ngIf="selectedTemplate?.id">
            {{!selectedTemplate.name ? '--' : selectedTemplate.name}}
        </label>

        <label *ngIf="selectedTemplate?.id">
            Alerting ID: {{!selectedTemplate.id ? '--' : selectedTemplate.id}}
        </label>
        <label *ngIf="!this.selectedTemplate?.id">New Template - {{selectedTemplate.name}}</label>
        <div class="flex align-top">
            <button *ngIf="!isEditable()" (click)="openTemplateEditFAQ()" aria-label="Why can't I edit this?" color="primary" id="openGroupFAQLock"
                        mat-icon-button
                        matTooltip="Why can't I edit this?" class="gutters align-baseline">
                <mat-icon class="align-top" color="primary">lock</mat-icon>
            </button>
            <button *ngIf="isEditable()" (click)="openTemplateEditFAQ()" aria-label="What is ownership?" color="primary" id="openGroupFAQUnlock"
                        mat-icon-button
                        matTooltip="What is ownership?" class="gutters align-baseline">
                <mat-icon class="align-top" color="primary">lock_open</mat-icon>
            </button>
        </div>
        <div>
                <button (click)="deleteTemplate(selectedTemplate.id)"
                        *ngIf="(admin || allowEditAccess && !loading) && selectedDeleteTemplate"
                        aria-label="Delete Template Button"
                        class="cmn-flex delete-icon" color="primary" id="deleteTemplate" mat-icon-button>
                    <mat-icon class="padded-left-lg padded-bottom-lg">delete</mat-icon>
                </button>
                <button (click)="closeTemplate()" aria-label="Close Template Button" color="primary" id="closeTemplateIcon"
                        mat-icon-button>
                    <mat-icon class="padded-left-lg padded-bottom-lg">close</mat-icon>
                </button>
        </div>
    </div>
        <div class="cmn-flex row gutters-lg padded-top-lg">
            <div id="right-column" class="cmn-flex column flex-50 gutters">
                <!-- Name -->
                <mat-form-field>
                    <mat-label>Name</mat-label>
                    <input [formControl]="templateName" (input)="checkLength(templateName, 50)"
                           [readonly]="!admin && !allowEditAccess" id="templateName" matInput maxlength="51"
                           minlength="4" required
                           type="text">
                    <mat-hint>Enter a name for your template.</mat-hint>
                    <mat-error>Invalid name - {{getErrorText(templateName.value)}}</mat-error>
                </mat-form-field>

                <!-- Instructions -->
                <mat-form-field>
                    <mat-label>Template Instructions</mat-label>
                    <textarea [formControl]="templateInstructions"
                              (input)="checkLength(templateInstructions, 2048)"
                              [readonly]="!admin && !allowEditAccess"
                              cdkAutosizeMaxRows="25"
                              cdkAutosizeMinRows="5"
                              cdkTextareaAutosize
                              id="templateInstructions"
                              maxlength="2048"
                              minlength="4"
                              matInput type="text">
                    </textarea>
                    <mat-hint>(Optional) State the purpose and any instructions for using this template.</mat-hint>
                    <mat-hint align="end">{{templateInstructions?.value?.length || "0"}} / 2048</mat-hint>
                </mat-form-field>

                <!-- Owner -->
                <mat-form-field>
                    <mat-label>Owner</mat-label>
                    <input [readonly]="true" [formControl]="templateOwner" id="templateOwner" matInput type="text">
                    <mat-hint>The creator of the template.</mat-hint>
                </mat-form-field>
                <mat-card-title>
                    <span>Template Message:</span>
                    <mat-card-subtitle>{{selectedTemplate.is_alert_manager ? "Supports Markdown and Handlebars" : "Supports Markdown"}}
                        <button (click)="openTemplatesFAQ()" aria-label="Template message help" color="primary" id="openTemplatesFAQ" mat-icon-button>
                            <mat-icon>help</mat-icon>
                        </button>
                    </mat-card-subtitle>
                </mat-card-title>
                <mat-form-field>
                <textarea [formControl]="templateText"
                          (input)="parseMessage();  checkLength(templateText, 2048)"
                          [readonly]="!admin && !allowEditAccess"
                          cdkAutosizeMaxRows="25"
                          cdkAutosizeMinRows="5"
                          cdkTextareaAutosize
                          id="templateText"
                          maxlength="1600"
                          minlength="4"
                          matInput required type="text">
                </textarea>
                    <mat-error>Invalid template - {{getErrorText(templateText.value)}}</mat-error>
                </mat-form-field>
                <div *ngIf="!loading">
                    <div class="cmn-flex space-between" *ngIf="admin || allowEditAccess">
                        <app-spinner-button (buttonClick)="save()" [disabled]="buttonsDisabled"
                                            [processing]="processing" buttonText="Save" color="primary">
                        </app-spinner-button>
                        <app-spinner-button (buttonClick)="reset()" [disabled]="buttonsDisabled"
                                            [processing]="processing" buttonText="Cancel" color="primary">
                        </app-spinner-button>
                    </div>
                </div>
            </div>
            <div id="left-column" class="cmn-flex column flex-50 gutters">
                <div class="cmn-flex row space-between align-items-center">
                    <mat-checkbox [(ngModel)]="selectedTemplate.is_alert_manager" (ngModelChange)="parseMessage()"
                                  [disabled]="!admin && !allowEditAccess"
                                  matTooltip="Check if this template is to be used by the Alert Manager endpoint instead of the Send Alert screen">
                        Alert Manager
                    </mat-checkbox>
                    <mat-checkbox [(ngModel)]="selectedTemplate.is_debug" [disabled]="!admin && !allowEditAccess"
                                  matTooltip="If checked, when using this template, tags will show in the message if data input for them. If unchecked, empty tags will be removed from the final message">
                        Show Tags In Message
                    </mat-checkbox>
                    <div class="cmn-flex space-between row gutters">
                        <button [matMenuTriggerFor]="menu"
                                class="mat-raised-button"
                                color="primary" id="tagHelp" [disabled]="!isEditable() || selectedTemplate.is_alert_manager" mat-raised-button>
                            <div class="cmn-flex align-center gutters-sm">
                                <div class="cmn-flex align-center gutters-sm">
                                    <span class="flex">Custom Tags</span>
                                    <mat-icon (click)="$event.stopPropagation(); openCustomTagsFAQ()"
                                              matTooltip="Click to open the FAQ to learn more about custom tags.">help
                                    </mat-icon>
                                </div>
                            </div>
                        </button>
                        <mat-menu #menu="matMenu">
                            <div *ngFor="let tag of customTags; let i = index">
                                <button mat-menu-item (click)="copy(tag[0])" matTooltip="Copy {{tag[0]}}"
                                        [matTooltipPosition]="'left'">
                                    <mat-icon class="tag-icon" fontSet="material-icons-outlined">{{tag[1]}}</mat-icon>
                                    <span>{{tag[0]}}</span>
                                </button>
                            </div>
                        </mat-menu>
                    </div>
                </div>

                <div *ngIf="templateInstructions?.value">
                    <label class="dark-gray">Template Instructions Preview</label>
                    <p id="instructionsPreview" [data]="templateInstructions.value" markdown ngPreserveWhitespaces></p>
                </div>

                <div *ngIf="!selectedTemplate?.is_alert_manager && (!selectedTemplate?.tags.length < 1)" class="mat-card-title">
                    Template Tag Inputs:
                </div>
                <mat-chip-list class="mat-chip-list-stacked">
                    <mat-chip (click)="openTagPopup(tag, i)" *ngFor="let tag of selectedTemplate?.tags; let i = index"
                              [attr.data-index]="i" [disabled]="!admin && !allowEditAccess"
                              class="cmn-flex row space-between align-center"
                              matTooltip="{{isCustom(tag) ? 'Tag options and prompt set by default for ' + tag.name : undefined}}">
                        <div class="cmn-flex flex row">
                            <div *ngIf="tag.input_type !== undefined" [ngSwitch]="tag.input_type"
                                 class="cmn-flex flex-33 row align-center gutters padded left-lg">
                                <mat-icon *ngSwitchCase="'DROPDOWN'" matTooltip="Dropdown">menu</mat-icon>
                                <mat-icon *ngSwitchCase="'RADIO'" matTooltip="Radio Buttons">radio_button_unchecked</mat-icon>
                                <mat-icon *ngSwitchCase="'TEXTBOX'" matTooltip="Text Input">horizontal_rule</mat-icon>
                                <mat-icon *ngSwitchCase="'TEXTAREA'" matTooltip="Text Area">article</mat-icon>
                                <mat-icon *ngSwitchCase="'DATE'" matTooltip="Date">date_range</mat-icon>
                                <mat-icon *ngSwitchCase="'APPLICATIONS'" matTooltip="Applications">computer</mat-icon>
                                <mat-icon *ngSwitchCase="'CLIENTS'" matTooltip="Clients">groups</mat-icon>
                                <mat-icon *ngSwitchCase="'CONFIRM'" matTooltip="Confirm">check</mat-icon>
                                <mat-icon *ngSwitchCase="'SENTBY'" matTooltip="Sent By">person</mat-icon>
                                <span class="flex spaced-left nowrap">{{summarize(tag.name)}}<span *ngIf="tag.required">*</span></span>
                            </div>
                            <div class="cmn-flex flex-50 row align-center gutters">
                                <span *ngIf="tag.prompt" [matTooltip]="summarizeTooltip(tag.prompt)"
                                      class="flex nowrap">{{summarize(tag.prompt)}}</span>
                                <span *ngIf="tag.tag_options" [matTooltip]="summarizeTooltip(tag.tag_options)"
                                      class="flex nowrap">Options: [{{summarize(tag.tag_options)}}]</span>
                            </div>
                            <div class="cmn-flex flex-15 row align-center gutters padded-left-lg">
                                <mat-icon *ngIf="!isConfirmTag(tag)" matTooltip="Editable">edit</mat-icon>
                                <mat-icon *ngIf="isConfirmTag(tag)" matTooltip="NOT Editable">lock</mat-icon>
                            </div>
                        </div>
                    </mat-chip>
                </mat-chip-list>
            </div>
        </div>
</mat-card>
